import {
  SOCKET_CONNECTED,
  UNREAD_COUNT,
  NOTIFICATION,
  SocketActionType,
} from '../types/socketType';

export const socketConnected = (data: any): SocketActionType => ({
  type: SOCKET_CONNECTED,
  payload: data,
});

export const unreadCountUpdate = (data: any): SocketActionType => ({
  type: UNREAD_COUNT,
  payload: data,
});

export const notificationsUpdate = (data: any): SocketActionType => ({
  type: NOTIFICATION,
  payload: data,
});
